import axios from "axios";

const endpoint_url = "/analytic/api/v1/petworld/product-sku-list";

const getProductSkuList = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url)
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error?.response?.data) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

export default getProductSkuList;
